module.exports = {
	"header": "Great interest in Spotin among fashion brands",
	"date": "2022/04/07",
	"imgSrc": "16.jpg",
	"imgAlt": "Great interest in Spotin among fashion brands",
	"ingress": "By: Affärer i Norr (in Swedish)",
	"externalLink": "https://affarerinorr.se/nyheter/2022/april/stort-intresse-for-spotin-bland-modevarumarken/"
};


//////////////////
// WEBPACK FOOTER
// ./pages/media/16/article.json
// module id = 86
// module chunks = 0